// Map internal dimension keys to human relationship language.
// The user should never see "conflict_repair" — they see "How you handle conflict".
// Shared across Compatibility, BehavioralScenarioRunner, and PartnerInvite.
export const DIMENSION_LABELS: Record<string, string> = {
  conflict_repair: 'How you handle conflict',
  emotional_regulation: 'How you manage emotions',
  family_boundary: 'Family pressure',
  decision_ownership: 'How you make decisions',
  attachment_security: 'How safe you feel',
  financial_style: 'Money habits',
  intimacy_expression: 'Showing affection',
  reliability: 'Following through',
  social_style: 'Social energy',
  social_boundaries: 'Social boundaries',
  daily_rituals: 'Daily rhythms',
  ritual_values: 'Values and rituals',
  autonomy_togetherness: 'Independence vs togetherness',
  communication_directness: 'Communication style',
  gottman_criticism: 'Criticism',
  gottman_contempt: 'Respect',
  gottman_defensiveness: 'Defensiveness',
  gottman_stonewalling: 'Shutting down',
  repair_frequency: 'Making up after fights',
  openness: 'Openness to new things',
  conscientiousness: 'Organization',
  extraversion: 'Social energy',
  agreeableness: 'Warmth',
  neuroticism: 'Emotional sensitivity',
  quality_satisfaction: 'Relationship satisfaction',
  quality_trust: 'Trust',
  quality_commitment: 'Commitment',
  quality_appreciation: 'Feeling appreciated',
  big_five_openness: 'Openness to new things',
  big_five_conscientiousness: 'Organization and follow-through',
  big_five_extraversion: 'Social energy',
  big_five_agreeableness: 'Warmth and cooperation',
  big_five_neuroticism: 'Emotional steadiness',
  repair_attempts: 'Making up after conflict',
  commitment_readiness: 'Commitment readiness',
  trust_capacity: 'Ability to trust',
  communication_style: 'Communication style',
  // Calibrated research dimensions (behavioral_assessment_research.py)
  conflict_repair_process: 'How you repair after conflict',
  shared_decision_process: 'How you make major decisions',
  financial_coordination: 'How you coordinate money',
  family_system_boundaries: 'How family influence is negotiated',
  household_labor_coordination: 'How household work is divided',
  career_location_planning: 'How careers and location are planned',
  caregiving_obligations: 'How elder and family care is handled',
  privacy_disclosure_boundaries: 'What stays private vs shared',
  material_disclosure_timing: 'How important information is disclosed',
  intimacy_consent_communication: 'How intimacy and consent are discussed',
  emotional_support_coordination: 'How support is coordinated under stress',
  ritual_religion_negotiation: 'How ritual and religion are negotiated',
  marriage_readiness_choice: 'How the decision to marry is reached',
  trust_past_relationships: 'How past relationships and trust are handled',
  children_parenting_process: 'How children and parenting decisions are made',
};

export function dimensionLabel(key: string): string {
  return DIMENSION_LABELS[key] ?? key.replace(/_/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase());
}
